import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { Column } from 'primereact/column';
import editor, { BodyWrapper } from '../../PrimeTable/helper';
import { DataTable } from 'primereact/datatable';
import mainAxios from '../../../services/mainAxios';
import { useAppContext } from '../../../AppContext'
import currencies from "../../../services/currencies.json"
import { toast } from 'react-toastify';
import { Checkbox } from 'primereact/checkbox';


const ContactBankAccounts = ({validationErrors,setValidationErrors,contact,setContact,valid}) => {
  const { t } = useTranslation("translations");
  const {selectedCompany:[selectedCompany]} =useAppContext()
  const defaultBankAcc={
    financialInstitution:null,
    accountNo: "",
    iban: "",
    currency: "ALL",
    company:parseInt(selectedCompany)
  }
  const [bankList, setBankList] = useState([]);

  useEffect (()=> {
    mainAxios
    .get("/api/financialInstitutions")
    .then( res=>{
      if(res.status==200){
        const banks = (res?.data ?? []).map(bank=>{return {label:bank.name,value:bank}});
        setBankList(banks);
      }
    })
  },[])


const handleDefaultBankAccount = ({ cellOptions, value }) => {
  const rowIndex = cellOptions.rowIndex;
  setContact((contact) => {
    const accounts = contact.accounts.map((acc, index) => ({
      ...acc,
      defaultValue: index === rowIndex, 
    }));
    return {
      ...contact,
      accounts,
    };
  });
};



const bankAccountColumns = [
  {
    header: "Financial Institution",
    field: "financialInstitution",
    style: { minWidth: '13rem', maxWidth: '14rem' },
    cellConfig:{
      type:"DROPDOWN",
      options:bankList,
      cellField:"financialInstitution"
    },
    body:(item,options)=><BodyWrapper parentKey={"accounts"}  validate={true} item={item} options={options} errors={validationErrors}>{item?.financialInstitution?.name}</BodyWrapper>
  },
  {
    header: "Account Number",
    field: "accountNo",
    style: { minWidth: '10rem', maxWidth: '11rem' },
    body:(item,options)=><BodyWrapper parentKey={"accounts"} validate={true} item={item} options={options} errors={validationErrors}>{item.accountNo}</BodyWrapper>
    
  },
  {
    header: "IBAN",
    field: "iban",
    style: { minWidth: '10rem', maxWidth: '11rem' },
    body:(item,options)=><BodyWrapper parentKey={"accounts"} validate={true} item={item} options={options} errors={validationErrors}>{item.iban}</BodyWrapper>
  },
  {
    header: t(["invoice.currency"]),
    field: "currency",
    style: { minWidth: '5rem', maxWidth: '6rem' },
    cellConfig:{
      type:"DROPDOWN",
      options:currencies,
    },
    body:(item,options)=><BodyWrapper parentKey={"accounts"} validate={true} item={item} options={options} errors={validationErrors}>{item.currency}</BodyWrapper>

  },
  {
    header: (
        <div className='p-column-header-content' data-tooltip-id="global-tooltip" data-tooltip-content={validationErrors?.["accounts.default"] ?validationErrors?.["accounts.default"].message:''}>
          <div className="p-column-title" style={validationErrors?.["accounts.default"]?{color:"red"}:{color:"#343a40"}}>Default</div>
        </div>
    ),
    field: "defaultValue",
    style: { minWidth: '5rem', maxWidth: '6rem' },
    editor:false,
    body:(item,cellOptions)=> ( 
          <Checkbox
            checked={item.defaultValue}
            onChange={(e) =>{
              handleDefaultBankAccount({cellOptions})
            }}
            />
     )

  },
];


  const addNewItem = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (!valid({validateOnlyBankAcc:true})) {
      toast.error(t("common.fixValidations"),{
        containerId: "all_toast",
      });
      return;
    }
    setContact((contact)=>{ 
      return {
        ...contact,
        accounts:[... (contact.accounts?? []),defaultBankAcc]
      }
    })
  };

  
  const removeItem = (e, item, index) => {
    e.preventDefault();
    if(contact?.accounts?.length==1){
      setValidationErrors((errors)=>{
        return Object.keys(errors).reduce((acc, key)=>{
          if(!/^accounts/.test(key)){
            acc[key]=errors[key]
          }
          return acc
        },{})
      })
    }
    setContact((contact) => {
      const newAcconts = (contact.accounts ?? []).filter((acc, i) => i !== index);
      return {
      ...contact,
      accounts: newAcconts,
    }});
  };


    const removeItemColumn = (
      <Column
        body={(...props) => {
          const rowIndex = props?.[1]?.rowIndex;
          return (
            <div className="d-flex justify-content-between ">
              <div>
                  <i
                    onClick={(e) => removeItem(e, contact.accounts[rowIndex], rowIndex)} 
                    className="pi pi-trash trash"
                  ></i>
              </div>
            </div>
          );
        }}
        headerStyle={{ minWidth: "60px",maxWidth:"60px", }}
        bodyStyle={{
          textAlign: contact?.accounts?.length > 1 ? "center" : "left",
        }}
        alignFrozen="right"
        frozen={true}
      />
    );
  
    const addRows = (
      <Column
        body={(...props) => {
          const rowIndex = props?.[1]?.rowIndex;
          return (
            <div className="d-flex justify-content-between">
              <div>
                {rowIndex === contact?.accounts.length - 1 ? (
                  <i
                    className="pi pi-plus-circle plus"
                    onClick={() => {
                      addNewItem();
                    }}
                  ></i>
                ) : null}
              </div>
            </div>
          );
        }}
        headerStyle={{ minWidth: "60px",maxWidth:"60px" }}
        bodyStyle={{
          textAlign: contact?.accounts?.length > 1 ? "center" : "left",
        }}
        alignFrozen="right"
        frozen={true}
      />
    );
  
  


      const handleBankAccountChange = ({ cellOptions, key, value, length,unitDefault=false }) => {
        const index = cellOptions?.rowIndex ?? 0;
        
        if (index < 0) return;
        value = length != undefined ? value.slice(0, length) : value;
        const keys=key?.split(".")
        setContact((contact) => {
          const content = {
            ...contact,
            accounts: [
              ...contact.accounts.map((oldAccount, oldIndex) =>{
                if(oldIndex !== index){
                  return oldAccount
                }
                  let newAcc
                  if(keys.length==1){
                    newAcc={
                    ...oldAccount,
                    [keys[0]]: value
                    } 
                  }else if(keys.length==2){
                   newAcc={
                    ...oldAccount,
                    [keys[0]]: {
                      ...(oldAccount[keys[0]] ? {...oldAccount[keys[0]]}:{}),
                      [keys[1]]: value,
                    },
                  }
                  }
                   return newAcc
              }
                

              ),
            ],
          }
          return content
        });
        return value;
      };
      

 const dynamicColumns = useMemo(()=>bankAccountColumns.map((col, i) => {
    const colProps = {
      style: { height: "2.6rem" },
      key: col?.field,
      field: col?.field,
      header: col?.header,
      menu:false,
      sortable:false,
      filter: false,
      showFilterMenu: false,
      ...col,
    };
    if (col?.editor!==false){
      colProps.editor = (options) => editor({validationErrors,setValidationErrors,parentKey:"accounts", col, t,cellOptions: options,onChange: ({ key, value, cellOptions }) =>handleBankAccountChange({key, value, cellOptions }) });
    }

      return <Column  {...colProps} />;
  }),[bankAccountColumns,contact?.accounts,handleBankAccountChange,valid]);

    return (
        <>
        <div className="d-flex flex-wrap justify-content-between align-items-center my-2" style={{width:"500px"}}>
          <DataTable
            scrollable
            scrollHeight="260px"
            editMode="cell"
            resizableColumns
            columnResizeMode="expand"  
            responsiveLayout="scroll"
            size="small"
            inline
            stripedRows
            order
            selectionMode="single"
            value={contact?.accounts ?? []}
            header={
              (contact?.accounts ?? []).length==0 ? (
              <div className='d-flex justify-content-start'>
                  <button
                    onClick={() => { setContact((contact)=>({...contact,accounts:[defaultBankAcc]})) }}
                    className="btn btn-sm btn-primary">
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />
                    Add 
                </button>
              </div>
              ):null
            }
          >
            { dynamicColumns }
            { addRows }
            { removeItemColumn }
    
          </DataTable>
        </div>
        </>
    )
}

export default ContactBankAccounts